import validate from '@/utils/validations/maxWithoutHtml'

export default {
    validate,
    message: (field, args) => {
        return `O campo ${field} deve conter no máximo ${args[0]} caracteres`
    }
}
